import SearchIcon from '@mui/icons-material/Search';
import { IconButton, InputAdornment } from '@mui/material';
import TextField from '@mui/material/TextField';
import { Dispatch, FC, SetStateAction, ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import ClearIcon from '@mui/icons-material/Clear';

interface ModulesSearchProps {
    searchString: string;
    setSearchString: Dispatch<SetStateAction<string>>;
}

const ModulesSearch: FC<ModulesSearchProps> = ({ searchString, setSearchString }) => {
    const { t } = useTranslation();

    const handleTextFieldChange = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchString(e.target.value);
    };

    return (
        <TextField
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon />
                    </InputAdornment>
                ),
                endAdornment: searchString && (
                    <InputAdornment position="end">
                        <IconButton onClick={() => setSearchString('')} edge="end" size="small">
                            <ClearIcon />
                        </IconButton>
                    </InputAdornment>
                ),
            }}
            size="small"
            placeholder={`${t('module')}...`}
            value={searchString}
            onChange={handleTextFieldChange}
            data-testid="module_search"
            sx={{ width: '100%' }}
        />
    );
};

export default ModulesSearch;
